import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat',
  pure: true,
})
export class DateFormatPipe implements PipeTransform {
  transform(inputDate: string): string {
    const date = new Date(inputDate);
    const monthYear = date.toLocaleDateString('default', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
    const hour = date.toLocaleTimeString('default', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
    return `${monthYear}, ${hour}`;
  }
}
